import React, { useEffect, useState } from "react";
import NavBarDark from "../components/NAVBAR/NavBarDark";
import Footer from "../components/FOOTER/Footer";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";
import { fetch_event } from "../api/event";
import moment from 'moment';
import GuestList from "../components/GuestList";
import { Calendar, MapPin } from "phosphor-react";


const PendingRSVPPage = () => {
  function getQueryParam(name, search) {
    const params = new URLSearchParams(search);
    return params.get(name);
  }

  
  const location = useLocation();
  const event_id = getQueryParam('event_id', location.search);



  const [event, setEvent] = useState(null)
  const [loading, setLoading] = useState(false)
  const [dataFetchFailed, setDataFetchFailed] = useState(false)
  const [errMsg, setErrMsg] = useState('')
  const [rsvpManagerSession, setRsvpManagerSession] = useState(null)


  const [inputValues, setInputValues] = useState({
    communityGroup: null,
    otp: "",
    comment: "",
  });
  const [err, setErr] = useState({    
    otp: "",
    communityGroup: "",
  });
  

  useEffect(() => {
    setUp()
  }, [])

  const setUp = () => {
    try {
      fetchEventData()
    } catch (error) {
      
    }
  }

  const fetchEventData = async () => {
    try {
      setLoading(true)
      
      const params = {
        event_id: event_id ?? '',
      }

      const res = await fetch_event(params)
      const response = await res.json()
      console.log('event', response)
      setLoading(false)
      if (res.ok) {
        setDataFetchFailed(false)
        setEvent(response.data)
        console.log('event', response.data)
      } else {
        setDataFetchFailed(true)
        setErrMsg(response?.message)
      }

    } catch (error) {
      setDataFetchFailed(true)
      setErrMsg("Oops... Something went wrong")
    }
  } 

  const verifyOtp = () => {

  }

  try {
    return (
      <>
        <Helmet>
          <title>
            Pending RSVP - Venco Events | All-in-one Community Management
            Software
          </title>
          <meta
            property="og:title"
            content="Sign up as a Referrer - Venco | All-in-one Community Management Software"
          />
          <meta
            name="twitter:title"
            content="Sign up as a Referrer - Venco | All-in-one Community Management Software"
          />
        </Helmet>
        <NavBarDark />

        <section className="container mx-auto my-10 xl:py-[100px] p-4">
          <div className="mb-8">
            <h1 className="text-[24px] md:text-2xl lg:text-[40px] text-center font-sora font-semibold text-foreground mb-10">
              Pending RSVP List
            </h1>

            <div className="flex flex-col sm:flex-row py-6 gap-6 content-center items-center justify-center justify-items-center bg-light-purple-200 rounded-lg border border-light-purple-500 ">
              <div className="bg-light-purple-150 w-[220px] h-[220px] rounded-xl content-center items-center justify-center justify-items-center">
                {
                  Boolean(event?.invitation_file) ? (
                    <img 
                      src={event?.invitation_file}
                      className=" bg-light-purple-150 w-[220px] h-[220px] rounded-xl"
                    />
                  ) : (
                    <p
                      className=" text-center text-[24px] text-purple-500 "
                    >
                      IMG
                    </p>
                  )
                }

              </div>
              <div className="sm:p-4 py-4 content-start sm:content-center item-center sm:items-start ">
                <p className="text-[18px] font-sora font-semibold text-foreground mb-3">
                  {event.title}
                </p>
                {
                  event?.schedules.map((schedule, index) => {
                    return (
                      <div 
                        className="flex items-center gap-2 mb-3 content-center"
                        key={index}
                      >
                        <div className="w-8 h-8 bg-neutrals-1000 rounded-full flex items-center justify-center flex-shrink-0">
                          <Calendar 
                            className="w-4 h-4 text-purple-300" 
                            weight="fill"
                          />
                        </div>
                        <div>
                          <p className="text-[14px] text-gray-800">
                          <span className="font-medium">{schedule.label}: </span> {moment(schedule.date).format('DD MMM YYYY')} {moment(schedule.start_time, "HH:mm:ss").format("HH:mm A")} - {moment(schedule.end_time, "HH:mm:ss").format("HH:mm A")}
                          </p>
                        </div>
                      </div>
                    )
                  })
                }

                <div className="flex items-center gap-2 mb-6">
                  <div className="w-8 h-8 bg-neutrals-1000 rounded-full flex items-center justify-center flex-shrink-0">
                    <MapPin 
                      className="w-4 h-4 text-purple-300" 
                      weight="fill"
                    />
                  </div>
                  <div>
                    <p className="text-[14px] text-gray-800">
                      {
                        Boolean(event?.is_community_event) ? 
                        `${event?.community_location ?? ''} ${event?.city ?? ''} ${event?.state ?? ''}` :
                        `${event?.address_line_1 ?? ''} ${event?.address_line_2 ?? ''} ${event?.city ?? ''} ${event?.state ?? ''}`
                      }
                    </p>
                  </div>
                </div>
              </div>
            </div>              
          </div>

          <GuestList 
            event_id={event_id}
            status={"Pending"}
          />
        </section>

        <Footer 
          
        />
      </>
    )
  } catch (error) {
    return (
      <div></div>
    )
  }
}

export default PendingRSVPPage;